// ingredient-filters.js

// 1️⃣ Loader: fetch your uploaded JSON asset and then initialize filters
async function loadFilters() {
  try {
    const res  = await fetch(GLOSSARY_JSON_URL);
    const list = await res.json();
    console.log('Loaded glossary terms:', list.length);
    window.GLOSSARY_LIST = list;
    initFilters();
  } catch (err) {
    console.error('Error loading glossary.json', err);
  }
}

// 2️⃣ Main filter setup (formerly inside DOMContentLoaded)
function initFilters() {
  // Build sets of unique filter values
  const aromas   = new Set(),
        perks    = new Set(),
        purposes = new Set();

  window.GLOSSARY_LIST.forEach(item => {
    if (item.aroma)     aromas.add(item.aroma);
    if (item.perks)     item.perks.split('·').forEach(p => perks.add(p));
    if (item.purpose)   item.purpose.split('·').forEach(f => purposes.add(f));
  });

  // Render checkboxes into each dropdown panel
  function renderCheckboxes(containerId, values, className) {
    const container = document.getElementById(containerId);
    if (!container) return;
    container.innerHTML = ''; // clear previous
    Array.from(values).sort().forEach(v => {
      const label = document.createElement('label');
      label.style.display = 'inline-flex';
      label.style.alignItems = 'center';
      label.style.marginRight = '8px';
      label.style.fontSize = '.85rem';

      const cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.className = className;
      cb.value = v;
      cb.style.marginRight = '4px';

      label.appendChild(cb);
      label.append(v);
      container.appendChild(label);
    });
  }

  renderCheckboxes('filter-aromas',    aromas,   'filter-aroma');
  renderCheckboxes('filter-perks',     perks,    'filter-perk');
  renderCheckboxes('filter-functions', purposes, 'filter-function');

  // Grab references
  const grid     = document.querySelector('.bf-grid'),
        cards    = grid ? Array.from(grid.children) : [],
        searchEl = document.getElementById('ingredient-search'),
        clearBtn = document.getElementById('clear-filters');

  // Main filtering logic
  function applyFilters() {
    const q    = searchEl ? searchEl.value.trim().toLowerCase() : '';
    const checkedAromas    = Array.from(document.querySelectorAll('.filter-aroma:checked'),    cb => cb.value);
    const checkedPerks     = Array.from(document.querySelectorAll('.filter-perk:checked'),     cb => cb.value);
    const checkedFunctions = Array.from(document.querySelectorAll('.filter-function:checked'), cb => cb.value);

    cards.forEach(card => {
      const titleEl = card.querySelector('.bf-card-title');
      const title   = titleEl ? titleEl.textContent.toLowerCase() : '';
      const data    = window.GLOSSARY_LIST.find(i => i.handle === card.dataset.handle) || {};

      const okSearch = !q    || title.includes(q);
      const okAroma  = !checkedAromas.length   || (data.aroma && checkedAromas.includes(data.aroma));
      const okPerk   = !checkedPerks.length    || (data.perks   && checkedPerks.some(p => data.perks.split('·').includes(p)));
      const okFunc   = !checkedFunctions.length|| (data.purpose && checkedFunctions.some(f => data.purpose.split('·').includes(f)));

      card.style.display = (okSearch && okAroma && okPerk && okFunc) ? '' : 'none';
    });

    const anyVisible = cards.some(card => card.style.display !== 'none');
    if (grid) grid.classList.toggle('empty', !anyVisible);
    const noResultsEl = document.querySelector('.no-results');
    if (noResultsEl) noResultsEl.style.display = anyVisible ? 'none' : 'block';
  }

  // Bind filter inputs
  const inputs = [searchEl, ...document.querySelectorAll('.filter-aroma, .filter-perk, .filter-function')];
  inputs.forEach(el => { if (el) el.addEventListener('input', applyFilters); });

  // Clear all button
  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      if (searchEl) searchEl.value = '';
      document.querySelectorAll('.filter-aroma, .filter-perk, .filter-function')
        .forEach(cb => cb.checked = false);
      applyFilters();
    });
  }

  // Dropdown toggle handlers: only one open at once
  document.querySelectorAll('.bf-filter-group > strong').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.parentElement;
      document.querySelectorAll('.bf-filter-group.open')
        .forEach(g => { if (g !== group) g.classList.remove('open'); });
      group.classList.toggle('open');
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', e => {
    if (!e.target.closest('.bf-filter-group')) {
      document.querySelectorAll('.bf-filter-group.open')
        .forEach(g => g.classList.remove('open'));
    }
  });

  // Initial filter pass
  applyFilters();
}

// 3️⃣ Wire everything up
document.addEventListener('DOMContentLoaded',  loadFilters);
document.addEventListener('shopify:section:load', loadFilters);
